/**
 * This hook is used to create a localized link for the current locale.
 * It uses the given url and locale to find the localized url in the localizedPathnames.json
 * file and returns the localized url.
 *
 **/

import { useCallback } from 'react';

import localizedPathnames from '../../translations/pathnames';

import { usePageContext } from './use-page-context';

import { getLocalStoragePreferredLocale, Locale } from '.';

export const useLocalizedLink = () => {
  const { locale } = usePageContext<{
    locale?: Locale;
  }>();

  return useCallback((url: string) => {
    const isExternalLink = /^http(s|):\/\//.test(url ?? '') ?? false;

    const _locale =
      locale?.valueOf() ?? getLocalStoragePreferredLocale() ?? Locale.EN_US;

    if (_locale === Locale.EN_US) {
      return url;
    }

    const pathname = localizedPathnames[url]?.[_locale as Locale];

    if (!pathname) {
      return url;
    }

    if (isExternalLink) {
      return pathname;
    }

    return `/${(_locale as string).toLowerCase()}${pathname}`;
  }, []);
};
